export const isValidPhone = (phone) => {
  // Spanish phone number format: +34 or 0034 followed by 9 digits
  // Accepts formats: +34666666666, 0034666666666, 666666666
  const phoneRegex = /^(?:(?:\+|00)34|0)?[6789]\d{8}$/;
  return phoneRegex.test(phone.replace(/\s/g, '')); // Remove spaces before testing
};
